import { useEffect } from 'react';

export const useBlockScroll = (shouldBlockScroll: boolean) => {
  useEffect(() => {
    // Guardar el valor original del overflow
    const originalOverflow = document.body.style.overflow;

    if (shouldBlockScroll) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // Restaurar el valor original del overflow al desmontar
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [shouldBlockScroll]);
};
